<template>
    <div>
      <kidjo-header
        price="0,99€"
        :trial-days="7" />
      <kidjo-features />
      <div class="reels-containter">

        <Images-reel />
      </div>
      
      <kidjo-features-section />
      <kidjo-faq />
      <Testimonial-crousel />
        <form @submit.prevent="handleSubmit" class="signup-form-footer">
            <img src="../assets/images/logo.svg" alt="Kidjo Logo" class="footer-logo">
            <h1 class="main-label">{{ $t('landing_page_ready_title') }}</h1>
            <p class="landing-sub-title">{{$t('landing_page_ready_subtitle')}}</p>
            <TextInputField
              class="set-width"
              :modelValue="email"
              @update:modelValue="email = $event"
              :field-type="'text'"
              name="email"
              :placeholder="$t('login_page_box_form_email')" 
              :has-error="email_error"
              :is-required-value="true"
              :error-message="errorMessage"
					/>
          <SubmitButton class="set-width" :label="$t('landing_page_subtitle_free_trial')" :isLoading="false" type="submit" />
        </form>
    </div>
  </template>
  
  <script>
  
	import TextInputField from '../components/TextInputField.vue';
	import SubmitButton from '../components/SubmitButton.vue';
	import KidjoHeader from '../components/KidjoHeader.vue';
	import KidjoFeatures from '../components/KidjoFeatures.vue';
	import KidjoFaq from '../components/KidjoFaq.vue';
	import KidjoFeatureSection from '../components/KidjoFeatureSection.vue';
  import ImagesReel from '../components/ImagesReel.vue';
  import TestimonialCrousel from '../components/TestimonialCrousel.vue';
  import { Events } from '../../src/utils/analytics'

  export default {
    name: 'App',
		components: {
			"TextInputField": TextInputField,
			"SubmitButton": SubmitButton,
			"kidjo-header": KidjoHeader,
			"kidjo-features": KidjoFeatures,
			"kidjo-faq": KidjoFaq,
			"kidjo-features-section": KidjoFeatureSection,
      "Images-reel": ImagesReel,
      "Testimonial-crousel": TestimonialCrousel
		},
    data() {
      return {
        email: '',
        email_error: false,
        errorMessage: 'Value Required'
      }
    },
    methods: {
      isValidEmail: function() {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(this.email);
      },
      handleSubmit: function() {
        if (this.email === '' || this.email === null) {
					this.email_error = true;
          this.errorMessage = "Value Required";
          return
				} else if (!this.isValidEmail()) {
          this.email_error = true;
          this.errorMessage = "Enter valid value";
          return
        }
        this.$store.commit('setAccountEmail', this.email);
        this.$store.dispatch('updateUserPayload', { userEmail: this.email }).then(() => {
          this.$store.dispatch('postAnalytics', Events.STARTFREETRIAL);
        })
        this.$router.replace({name: 'register'});

      }
    }
  }
  </script>
  
  <style scoped>
  .app {
    font-family: "Nunito-Regular";
    background-color: white;
    color: #020076;
  }
  .footer-logo {
    display: flex;
    justify-content: center;
    width: 40%;
  }
  
  .price {
    margin: 2rem 0;
  }
  
  .amount {
    font-size: 3rem;
    font-weight: bold;
  }
  
  .period {
    display: block;
    font-size: 1.2rem;
  }
  
  .signup-form-footer {
    display: grid;
    row-gap: 10px;
    max-width: 30%;
    margin: 0 auto;
    align-items: center;
    justify-items: center;
    text-align: center;
    margin-block: 3rem;
    color: #020076;
    font-family: "Nunito-Regular";

    @media (orientation: portrait) {
      max-width: 80%;
    }
    @media (orientation: landscape) and (max-height: 480px) {
      max-width: 35%;
    }
    @media (orientation: portrait) and (min-width: 1000px) {
      width: 55%;
    }

    @media screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
      width: 53%;
    }
  }
  .set-width {
    max-width: 100%;
    @media (min-width: 1024px) {
      max-width: 80%;
    }
  }
  
  .main-label {
    font-size: 22px;
    font-weight: bold;
    font-family: "Nunito-Regular";
  }
  .landing-sub-title {
    font-family: "Nunito-Regular";
    text-align: center;
  }

  @media (max-width: 768px) {
    .hero-content {
      padding: 1rem;
    }
  }
  .reels-containter {
    overflow: hidden;
    /* height: 650px;
    padding-top: 20px; */
    display: flex;
    align-items: flex-start;

    @media (min-width: 1280px) {
      /* margin-bottom: -300px; */
    }
    @media (orientation: portrait) {
      /* margin-bottom: -130px; */
      /* height: 500px; */
    }
  }
  </style>